'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBadgePercent } from '@fortawesome/pro-solid-svg-icons';
import { AnalyticsRef } from '@components/analytics-ref';
import { BaseModal } from '@components/base-modal';
import { Button } from '@components/button';
import { Link } from '@components/link';
import { Typography } from '@components/typography';
import { useToggle } from '@hooks';
import { routes } from '@routes';
const MODAL_TITLE = 'How Savvy saves you hundreds';
const MODAL_BODY = "Savvy connects travelers directly with professional property managers. Same properties you'd find on Airbnb. No markup. Average savings of $500 per booking.";
export const HowItWorksBadge: React.FC = () => {
  const $ = _c(16);
  const {
    on,
    setOn,
    setOff
  } = useToggle(false);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <FontAwesomeIcon icon={faBadgePercent} className="h-3.5 w-3.5" aria-hidden={true} />;
    t1 = <span className="font-medium">Same stays, hundreds less.</span>;
    t2 = <span className="underline">Learn more</span>;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== setOn) {
    t3 = <AnalyticsRef name="how_it_works_badge" className="absolute bottom-14 left-6 z-10 sm:bottom-4 sm:left-4"><Button variant="outlined" size="sm" onClick={setOn} className="gap-1.5 whitespace-nowrap bg-white px-3 text-xs font-normal sm:px-4 sm:text-sm">{t0}{t1}{t2}</Button></AnalyticsRef>;
    $[3] = setOn;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Typography component="h2" variant="title4" className="pr-8 text-primary-main">{MODAL_TITLE}</Typography>;
    t5 = <Typography component="p" variant="body2" className="mt-3 text-primary-main/80">{MODAL_BODY}</Typography>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== setOff) {
    t6 = <div className="px-6 pb-6 pt-6 sm:px-8">{t4}{t5}<div className="mt-5"><AnalyticsRef name="how_it_works_modal_cta"><Link isButton={true} to={routes.howItWorks} onClick={setOff}>More details</Link></AnalyticsRef></div></div>;
    $[7] = setOff;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== on || $[10] !== setOff || $[11] !== t6) {
    t7 = <BaseModal isOpen={on} onClose={setOff} size="sm" ariaLabel={MODAL_TITLE}>{t6}</BaseModal>;
    $[9] = on;
    $[10] = setOff;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t7) {
    t8 = <>{t3}{t7}</>;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
HowItWorksBadge.displayName = 'HowItWorksBadge';